import { MessagesState } from './types';

export const defaultDelay = 5000;

export const initialState: MessagesState = {
  isOpen: false,
  message: '',
  delay: defaultDelay,
};
